import styled, { keyframes } from 'styled-components'

// ── paleta do PORTAL DO RESPONSÁVEL (esmeralda) ──
const TEAL = '#0f6e52'
const TEAL_LIGHT = '#14916b'
const TEAL_DEEP = '#0a4d3a'
const TEAL_SOFT = '#e6f4ee'
//const CORAL = 'var(--coral)'
const GRAY_BG = '#f4f7f5'
const GRAY_LINE = '#e0e8e4'
const GRAY_TEXT = '#566b62'
const GRAY_DARK = '#23332c'
//const TEAL_GLOW = 'rgba(15, 110, 82, 0.22)'
const GREEN = 'var(--green)'
const RED = 'var(--red, #dc2626)'
const AMBER = '#a06cf0'
const GREEN_SOFT = 'rgba(29, 139, 90, 0.14)'
const RED_SOFT = 'rgba(192, 57, 43, 0.12)'
const AMBER_SOFT = 'rgba(200, 138, 4, 0.15)'

const bp = { tablet: '900px', mobile: '540px' }

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
`
const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`

export const Page = styled.div`
  position: fixed;
  inset: 0;
  overflow-y: auto;
  box-sizing: border-box;
  z-index: 1;
  background:
    radial-gradient(1200px 380px at 75% -120px, rgba(20, 145, 107, 0.08), transparent 70%),
    ${GRAY_BG};
`

// === barra superior com voltar ===
export const TopBar = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 32px;
  background: ${TEAL_DEEP};
  color: #fff;

  @media (max-width: ${bp.mobile}) {
    padding: 12px 16px;
  }
`

export const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 1.5px solid rgba(255, 255, 255, 0.35);
  background: rgba(255, 255, 255, 0.10);
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  padding: 8px 16px;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.12s ease;

  &:hover { background: rgba(255, 255, 255, 0.2); border-color: rgba(255, 255, 255, 0.6); transform: translateX(-2px); }
`

export const TopBarTitle = styled.span`
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.3px;
  color: rgba(255, 255, 255, 0.9);
`

// === hero com identidade do aluno ===
export const Hero = styled.header`
  width: 100%;
  background: linear-gradient(135deg, ${TEAL} 0%, ${TEAL_DEEP} 100%);
  color: #fff;
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    right: -140px;
    top: -160px;
    width: 420px;
    height: 420px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.10) 0%, transparent 70%);
    pointer-events: none;
  }
`

export const HeroInner = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 36px 32px 40px;
  display: flex;
  align-items: center;
  gap: 22px;
  position: relative;
  z-index: 1;

  @media (max-width: ${bp.mobile}) {
    padding: 26px 18px 30px;
    gap: 16px;
  }
`

export const HeroAvatar = styled.div`
  flex-shrink: 0;
  width: 88px;
  height: 88px;
  border-radius: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 30px;
  color: #fff;
  text-transform: uppercase;
  background: rgba(255, 255, 255, 0.16);
  border: 2px solid rgba(255, 255, 255, 0.3);

  @media (max-width: ${bp.mobile}) {
    width: 64px;
    height: 64px;
    border-radius: 20px;
    font-size: 22px;
  }
`

export const HeroInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
  min-width: 0;
`

export const HeroName = styled.h1`
  margin: 0;
  font-size: clamp(22px, 3vw, 32px);
  font-weight: 800;
  letter-spacing: -0.4px;
  line-height: 1.12;
  word-break: break-word;
`

export const HeroSub = styled.p`
  margin: 0;
  font-size: 14.5px;
  color: rgba(255, 255, 255, 0.85);
`

export const HeroClassInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px 16px;
  margin-top: 2px;
`

export const HeroClassLine = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13.5px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.92);

  svg {
    opacity: 0.85;
    flex-shrink: 0;
  }
`

export const StatusBadge = styled.span`
  align-self: flex-start;
  margin-top: 2px;
  font-size: 12px;
  font-weight: 700;
  text-transform: capitalize;
  padding: 4px 14px;
  border-radius: 999px;
  ${({ $status }) => {
    switch (($status || '').toLowerCase()) {
      case 'ativo': return `color: #fff; background: rgba(29, 139, 90, 0.5); border: 1px solid rgba(255,255,255,0.4);`
      case 'transferido': return `color: #fff; background: rgba(224, 122, 95, 0.55); border: 1px solid rgba(255,255,255,0.4);`
      default: return `color: #fff; background: rgba(255, 255, 255, 0.18); border: 1px solid rgba(255,255,255,0.3);`
    }
  }}
`

// === conteúdo ===
export const Content = styled.main`
  max-width: 1100px;
  margin: 0 auto;
  padding: 28px 32px 56px;
  animation: ${fadeUp} 0.4s ease;

  @media (max-width: ${bp.mobile}) {
    padding: 22px 18px 44px;
  }
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 18px;

  @media (max-width: ${bp.mobile}) {
    grid-template-columns: 1fr;
    gap: 14px;
  }
`

// === seção de botões de acesso rápido ===
export const ActionsSection = styled.section`
  margin-bottom: 26px;
`

export const ActionsTitle = styled.h2`
  margin: 0 0 14px;
  font-size: 13px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.7px;
  color: ${GRAY_TEXT};
`

export const ActionGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  gap: 14px;

  @media (max-width: ${bp.mobile}) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 18px;
  background: var(--surface);
  border: 1px solid ${GRAY_LINE};
  border-radius: 16px;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  transition: box-shadow 0.18s ease, transform 0.14s ease, border-color 0.18s ease;

  .go {
    margin-left: auto;
    color: ${GRAY_LINE};
    flex-shrink: 0;
    transition: color 0.15s ease, transform 0.15s ease;
  }

  &:hover {
    box-shadow: 0 12px 26px rgba(15, 110, 82, 0.12);
    transform: translateY(-3px);
    border-color: ${TEAL_SOFT};
  }
  &:hover .go { color: ${TEAL}; transform: translateX(3px); }
  &:active { transform: translateY(-1px); }
  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(20, 145, 107, 0.25);
    border-color: ${TEAL_LIGHT};
  }
`

export const ActionIcon = styled.span`
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: linear-gradient(135deg, ${TEAL}, ${TEAL_LIGHT});
  box-shadow: 0 5px 14px rgba(15, 110, 82, 0.22);
`

export const ActionLabel = styled.span`
  font-size: 15px;
  font-weight: 700;
  color: ${GRAY_DARK};
  line-height: 1.2;
`

export const Card = styled.section`
  background: var(--surface);
  border: 1px solid ${GRAY_LINE};
  border-radius: 18px;
  padding: 22px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  transition: box-shadow 0.18s ease, transform 0.12s ease;

  &:hover {
    box-shadow: 0 10px 24px rgba(15, 110, 82, 0.09);
    transform: translateY(-2px);
  }
`

export const CardTitle = styled.h3`
  margin: 0;
  display: flex;
  align-items: center;
  gap: 9px;
  font-size: 13px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${TEAL};
  padding-bottom: 12px;
  border-bottom: 1px solid ${GRAY_LINE};

  svg { color: ${TEAL_LIGHT}; }
`

export const InfoList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const InfoIcon = styled.span`
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${TEAL_SOFT};
  color: ${TEAL};
`

export const InfoData = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
`

export const InfoLabel = styled.span`
  font-size: 11.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: ${GRAY_TEXT};
`

export const InfoValue = styled.span`
  font-size: 14.5px;
  font-weight: 600;
  color: ${GRAY_DARK};
  word-break: break-word;
`

// === vazio / erro ===
export const EmptyBox = styled.div`
  background: var(--surface);
  border: 1px dashed ${GRAY_LINE};
  border-radius: 18px;
  padding: 48px 28px;
  text-align: center;
  color: ${GRAY_DARK};
  font-size: 16px;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`

export const EmptyIcon = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
  ${({ $tone }) =>
    $tone === 'error'
      ? `color: ${RED}; background: rgba(192, 57, 43, 0.10);`
      : `color: ${TEAL}; background: ${TEAL_SOFT};`}
`

// === skeleton ===
export const SkeletonBlock = styled.div`
  width: ${({ $w }) => $w || '100%'};
  height: ${({ $h }) => $h || '20px'};
  border-radius: ${({ $round }) => ($round ? '26px' : '10px')};
  background: rgba(255, 255, 255, 0.25);
  animation: ${shimmer} 1.4s infinite linear;
  background-size: 800px 100%;
`

export const SkeletonLine = styled.div`
  width: ${({ $w }) => $w || '100%'};
  height: ${({ $h }) => $h || '12px'};
  border-radius: 7px;
  margin: 4px 0;
  ${({ $light }) =>
    $light
      ? `background: rgba(255,255,255,0.25);`
      : `background: linear-gradient(90deg, #eef2f0 25%, #e2e8e5 37%, #eef2f0 63%);`}
  background-size: 800px 100%;
  animation: ${shimmer} 1.4s infinite linear;
`
/* ═══════════ MODAL DE FREQUÊNCIA (calendário) ═══════════ */

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 50;
  background: rgba(10, 40, 30, 0.55);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  animation: ${fadeUp} 0.2s ease;

  @media (max-width: ${bp.mobile}) {
    padding: 0;
    align-items: stretch;
  }
`

export const ModalBox = styled.div`
  width: 100%;
  max-width: 1000px;
  max-height: 90vh;
  background: ${GRAY_BG};
  border-radius: 22px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.35);

  @media (max-width: ${bp.mobile}) {
    max-height: 100vh;
    max-width: 100%;
    border-radius: 0;
  }
`

export const ModalHeader = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 20px 24px;
  background: linear-gradient(135deg, ${TEAL} 0%, ${TEAL_DEEP} 100%);
  color: #fff;
`

export const ModalTitle = styled.h3`
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 17px;
  font-weight: 800;
  letter-spacing: -0.2px;
`

export const ModalClose = styled.button`
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease;
  &:hover { background: rgba(255, 255, 255, 0.24); }
`

export const YearNav = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  padding: 16px;
  background: var(--surface);
  border-bottom: 1px solid ${GRAY_LINE};
`

export const YearButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 12px;
  border: 1px solid ${GRAY_LINE};
  background: ${GRAY_BG};
  color: ${TEAL};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
  &:hover:not(:disabled) { background: ${TEAL_SOFT}; border-color: ${TEAL_SOFT}; }
  &:disabled { opacity: 0.4; cursor: not-allowed; }
`

export const YearLabel = styled.span`
  font-size: 22px;
  font-weight: 800;
  color: ${TEAL};
  min-width: 90px;
  text-align: center;
  letter-spacing: 0.5px;
`

export const Legend = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 18px;
  padding: 12px 20px;
  background: var(--surface);
  border-bottom: 1px solid ${GRAY_LINE};

  @media (max-width: ${bp.mobile}) { gap: 12px; padding: 10px 14px; }
`

export const LegendItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 12.5px;
  font-weight: 600;
  color: ${GRAY_TEXT};
`

export const LegendDot = styled.span`
  width: 13px;
  height: 13px;
  border-radius: 5px;
  ${({ $status }) => {
    switch ($status) {
      case 'P': return `background: ${GREEN};`
      case 'F': return `background: ${RED};`
      case 'FJ': return `background: ${AMBER};`
      default: return `background: var(--surface); border: 1.5px solid ${GRAY_LINE};`
    }
  }}
`

export const ModalBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px 24px 28px;

  @media (max-width: ${bp.mobile}) { padding: 16px 14px 24px; }
`

export const ModalLoading = styled.div`
  padding: 60px 20px;
  text-align: center;
  color: ${GRAY_TEXT};
  font-size: 15px;
  font-weight: 600;
`

/* resumo */
export const SummaryRow = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 24px;

  @media (max-width: ${bp.mobile}) {
    grid-template-columns: repeat(2, 1fr);
  }
`

export const SummaryCard = styled.div`
  border-radius: 14px;
  padding: 16px 14px;
  text-align: center;
  border: 1px solid ${GRAY_LINE};
  ${({ $tone }) => {
    switch ($tone) {
      case 'P': return `background: ${GREEN_SOFT}; border-color: transparent;`
      case 'F': return `background: ${RED_SOFT}; border-color: transparent;`
      case 'FJ': return `background: ${AMBER_SOFT}; border-color: transparent;`
      default: return `background: ${TEAL_SOFT}; border-color: transparent;`
    }
  }}
`

export const SummaryValue = styled.div`
  font-size: 26px;
  font-weight: 800;
  line-height: 1;
  color: ${GRAY_DARK};
`

export const SummaryLabel = styled.div`
  margin-top: 5px;
  font-size: 11.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  color: ${GRAY_TEXT};
`

/* grade de meses */
export const MonthsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 16px;

  @media (max-width: ${bp.mobile}) {
    grid-template-columns: 1fr;
  }
`

export const MonthCard = styled.div`
  background: var(--surface);
  border: 1px solid ${GRAY_LINE};
  border-radius: 16px;
  padding: 16px;
`

export const MonthName = styled.div`
  text-align: center;
  font-size: 14px;
  font-weight: 800;
  color: ${TEAL};
  margin-bottom: 12px;
  text-transform: capitalize;
`

export const WeekHeader = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 3px;
  margin-bottom: 6px;

  span {
    text-align: center;
    font-size: 10.5px;
    font-weight: 700;
    color: ${GRAY_TEXT};
    padding: 2px 0;
  }
`

export const DaysGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 3px;
`

export const DayCell = styled.div`
  aspect-ratio: 1 / 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11.5px;
  font-weight: 600;
  border-radius: 7px;
  cursor: default;
  transition: transform 0.1s ease;

  ${({ $empty }) => $empty && `visibility: hidden;`}

  ${({ $status }) => {
    switch ($status) {
      case 'P': return `background: ${GREEN}; color: #fff; font-weight: 700;`
      case 'F': return `background: ${RED}; color: #fff; font-weight: 700;`
      case 'FJ': return `background: ${AMBER}; color: #fff; font-weight: 700;`
      default: return `background: #f1f4f2; color: #9aa5a0;`
    }
  }}

  &:hover { transform: ${({ $status, $empty }) => ($status && !$empty ? 'scale(1.12)' : 'none')}; }
`